import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id", "data-tour"]
const _hoisted_2 = { class: "map-renderer__map-info__for-img width-100" }
const _hoisted_3 = { class: "map-renderer__map-legend__for-img" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_map_info = _resolveComponent("map-info")!
  const _component_map_legend = _resolveComponent("map-legend")!
  const _component_map_options = _resolveComponent("map-options")!
  const _component_map_details = _resolveComponent("map-details")!
  const _component_map_footer = _resolveComponent("map-footer")!
  const _component_map_popup = _resolveComponent("map-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      id: _ctx.MAP_ID,
      class: _normalizeClass(['map-renderer', { 'cursor-pointer': _ctx.showCursorPointer }]),
      "data-tour": _ctx.TourSelector.MAP
    }, [
      _createVNode(_component_map_info, {
        class: "map-renderer__map-info",
        title: _ctx.mapInfoTitle,
        list: _ctx.mapInfoList,
        "variable-description": _ctx.variableDescription
      }, null, 8, ["title", "list", "variable-description"]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_map_info, {
          id: _ctx.MAP_INFO_ID_FOR_IMG,
          class: "map-renderer__map-info",
          title: _ctx.mapInfoTitle,
          list: _ctx.mapInfoList,
          "variable-description": _ctx.variableDescription
        }, null, 8, ["id", "title", "list", "variable-description"])
      ]),
      _createVNode(_component_map_legend, {
        class: "map-renderer__map-legend",
        "data-tour": _ctx.TourSelector.LEGEND,
        list: _ctx.legendArray,
        unit: _ctx.legendUnit,
        "to-mark-unused": true
      }, null, 8, ["data-tour", "list", "unit"]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_map_legend, {
          id: _ctx.LEGEND_ID_FOR_IMG,
          list: _ctx.legendArray,
          unit: _ctx.legendUnit
        }, null, 8, ["id", "list", "unit"])
      ]),
      _createVNode(_component_map_options, {
        class: "map-renderer__map-options",
        "show-popover": _ctx.showPopover,
        "current-view": _ctx.currentView,
        "show-climate-data": _ctx.showClimateData,
        "shadow-root": _ctx.shadowRoot,
        onZoomIn: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateZoomBy(_ctx.zoomStep))),
        onZoomOut: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateZoomBy(-_ctx.zoomStep))),
        onShowPopover: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onShowPopover())),
        onDownloadImage: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onDownloadImage())),
        onDownloadPDF: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onDownloadPDF())),
        onDownloadFile: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onDownloadFile())),
        onChangeView: _ctx.onViewChange,
        onToggleClimateData: _ctx.toggleClimateData
      }, null, 8, ["show-popover", "current-view", "show-climate-data", "shadow-root", "onChangeView", "onToggleClimateData"]),
      _createVNode(_component_map_details, {
        class: "map-renderer__map-details",
        "file-id": _ctx.fileId,
        filters: _ctx.filters,
        "show-details": _ctx.clickInBalkanArea && !!_ctx.selectedFeatCoordinates,
        datasets: _ctx.chartDatasets,
        "y-label": _ctx.$t(`unit.${_ctx.data.unit}`),
        "chart-title": _ctx.chartTitle,
        "has-no-csv-data": _ctx.hasNoCSVData,
        "selected-feat-coordinates": _ctx.selectedFeatCoordinates,
        "show-subgrid": _ctx.showNestedGrid,
        "subgrid-disabled": _ctx.nestedGridDisabled,
        "shadow-root": _ctx.shadowRoot,
        onHideDetails: _ctx.unselectRegion,
        onToggleGrid: _ctx.toggleNestedGrid
      }, null, 8, ["file-id", "filters", "show-details", "datasets", "y-label", "chart-title", "has-no-csv-data", "selected-feat-coordinates", "show-subgrid", "subgrid-disabled", "shadow-root", "onHideDetails", "onToggleGrid"]),
      _createVNode(_component_map_footer, {
        class: "map-renderer__map-footer",
        lon: _ctx.footerLon,
        lat: _ctx.footerLat,
        ratio: _ctx.footerMapRatio
      }, null, 8, ["lon", "lat", "ratio"])
    ], 10, _hoisted_1),
    _createVNode(_component_map_popup, {
      id: _ctx.POPUP_ID,
      data: _ctx.popupData,
      onClose: _ctx.closePopup
    }, null, 8, ["id", "data", "onClose"])
  ], 64))
}